module.exports = __webpack_public_path__ + "media/images/clear-lock-blue-d6c57e4f6c7afb4c566a07c04dff39a6.svg";